// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".giving-app__content-wrapper{max-width:1300px;margin-left:auto;margin-right:auto}", "",{"version":3,"sources":["webpack://./src/Components/GivingApp.scss"],"names":[],"mappings":"AAAA,6BACE,gBAAA,CACA,gBAAA,CACA,iBAAA","sourcesContent":[".giving-app__content-wrapper {\n  max-width: 1300px;\n  margin-left: auto;\n  margin-right: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
